
export function errorHitMsHealth() {
  console.log("errorHitMsHealth")
  console.log (twigData.msHealth)
  
  if (!twigData.msHealth.airQuality) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_air-quality_daily' });
  }
  if (!twigData.msHealth.flu) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_flu_daily' });
  }
  if (!twigData.msHealth.vitaminD) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_vitamin-d_daily' });
  }
  if (!twigData.msHealth.mosquito) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_mosquito_daily' });
  }
  if (!twigData.msHealth.radiation) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_uv_daily' });
  }
  if (!twigData.msHealth.skindryness) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_skin-dryness_daily' });
  }
}

export function errorHitNearbyCities() {
  console.log("errorHitNearbyCities")
  console.log(twigData.nearbyCities)

  twigData.nearbyCities.forEach((city, index) => {
    if (!city.momentTemperature && city.momentTemperature != 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_now_temperature_city_${index + 1}` });
    }
    if (!city.momentSensation && city.momentSensation != 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_now_thermal-sensation_city_${index + 1}` });
    }

  })
}

export function errorHitNearbyAirports() {
  console.log("errorHitNearbyAirports")
  console.log(twigData.nearbyAirports)
  twigData.nearbyAirports.forEach((airport, index) => {
    if (!airport.weather.temperature && airport.weather.temperature != 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_now_temperature_airport_${index + 1}` });
    }
    if (!airport.weather.sensation && airport.weather.sensation != 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_now_thermal-sensation_airport_${index + 1}` });
    }
  })
}

export function errorHitClimatology() {
  console.log("errorHitClimatology")
  console.log(twigData.volumeOfRain.averageMonthlyRainfall)
  if (!twigData.volumeOfRain.averageMonthlyRainfall) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_climatology_precipitation' });
  }
}

export function errorHitObserved() {
  console.log("errorHitObserved")
  console.log(twigData.volumeOfRain.sumRainInTheMonth)
  if (!twigData.volumeOfRain.sumRainInTheMonth && twigData.volumeOfRain.sumRainInTheMonth != 0) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_observed_precipitation' });
  }
}

export function errorHitForecastDaily() {
  console.log("errorHitForecastDaily")
  console.log(twigData.dailyForecast)

  twigData.dailyForecast.forEach((forecast, index) => {
    if (!forecast.moonPhases.phase) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_moon-phase_daily_${index + 1}` });
    }
    if (!forecast.sun.sunset || !forecast.sun.sunshine) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_sun_daily_${index + 1}` });
    }
    if (!forecast.humidity.min || !forecast.humidity.max) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_humidity_daily_${index + 1}` });
    }
    if (!forecast.wind.avgVelocity && forecast.wind.avgVelocity != 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_wind-velocity_daily_${index + 1}` });
    }
    if (!forecast.wind.direction || !forecast.wind.direction_degrees) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_wind-direction_daily_${index + 1}` });
    }
    if (!forecast.temperature.max && forecast.temperature.max != 0) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_temperature_daily_${index + 1}` });
    }
    if (!forecast.rain.precipitation && forecast.rain.precipitation != 0) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_precipitation_daily_${index + 1}` });
    }
    if (!forecast.rain.probability && forecast.rain.probability != 0) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_precipitation-probability_daily_${index + 1}` });
    }
    if (!forecast.textIcon.icon.day) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_icon_daily_${index + 1}` });
    }
    if (!forecast.textIcon.icon.afternoon || !forecast.textIcon.icon.dawn || !forecast.textIcon.icon.morning || !forecast.textIcon.icon.night) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_icon_period_${index + 1}` });
    }
  });
}

export function errorHitForecastHourly() {
  console.log("errorHitForecastHourly")
  console.log(twigData.hourlyForecast)
  Object.keys(twigData.hourlyForecast).forEach((day, dayIndex) => {
    if (dayIndex >= 3) return;
    
    twigData.hourlyForecast[day].forEach((hour, hourIndex) => {

      if (!hour.temperature.temperature && hour.temperature.temperature != 0) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_temperature_hourly_${dayIndex + 1}-${hourIndex}` });
      }
      
      if (!hour.pressure.pressure && hour.pressure.pressure != 0) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_pressure_hourly_${dayIndex + 1}-${hourIndex}` });
      }

      if (!hour.humidity.relativeHumidity && hour.humidity.relativeHumidity != 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_humidity_hourly_${dayIndex + 1}-${hourIndex}` });
      }

      if (!hour.wind.velocity && hour.wind.velocity != 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_wind-velocity_hourly_${dayIndex + 1}-${hourIndex}` });
      }

      if ((!hour.wind.direction || !hour.wind.direction_degrees) && hour.wind.direction_degrees != 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_wind-direction_hourly_${dayIndex + 1}-${hourIndex}` });
      }

      if (!hour.rain.precipitation) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ 'event': 'error_hit', 'name': `data_aggregator_forecast_precipitation_hourly_${dayIndex + 1}-${hourIndex}` });
      }
    })
  })
}

export function errorHitFifteenDays() {
  console.log("errorHitFifteenDays")
  console.log(twigData.hourlyForecast)
  if (!twigData.msHealth) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_health' });
  } else {
    errorHitMsHealth()
  }

  if (!twigData.volumeOfRain) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_climatology' });
  } else {
    errorHitClimatology();
    errorHitObserved();
  }

  if (!twigData.dailyForecast) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_daily' });
  } else {
    errorHitForecastDaily()
  }

  if (!twigData.hourlyForecast) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_forecast_hourly' });
  } else {
    errorHitForecastHourly()
  }

  if (!twigData.nearbyCities || twigData.nearbyCities == []) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_now_nearby-cities' });
  } else {
    errorHitNearbyCities()
  }

  if (!twigData.nearbyAirports || twigData.nearbyAirports == []) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_now_nearby-airports' });
  } else {
    errorHitNearbyAirports()
  }

}
